import { render, staticRenderFns } from "./ReadingListeningResult.vue?vue&type=template&id=122dd1a8&scoped=true"
import script from "./ReadingListeningResult.vue?vue&type=script&lang=js"
export * from "./ReadingListeningResult.vue?vue&type=script&lang=js"
import style0 from "./ReadingListeningResult.vue?vue&type=style&index=0&id=122dd1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122dd1a8",
  null
  
)

export default component.exports